export const SELECTED_MENU = 'SELECTED_MENU'
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'
export const ACTIVE_STEP = 'ACTIVE_STEP'